export const SAVED_ROLES_EVENTS = {
  SAVE_ROLE_CREATE_INITIATED: createSavedRoleEventKey("create_initiated"),
  SAVE_ROLE_DELETE_INITIATED: createSavedRoleEventKey("delete_initiated"),
} as const;

function createSavedRoleEventKey<const TKey extends string>(eventKey: TKey) {
  return `saved_role:${eventKey}` as const;
}

export const GAME_PLAN_EVENTS = {
  PS_ADD_TO_GAME_PLAN_SUCCESS: (payload: {
    jobId: number;
    gamePlanIds: Array<string>;
    flow: "direct" | "selected";
  }) => ({
    name: "ps_game_plan:add_success",
    payload,
  }),
} as const;

export const SHORTLIST_EVENTS = {
  CREATE: (payload: {
    participantIds: Array<string>;
    source: "search" | "sidebar_empty_state" | "sidebar_button";
    override: boolean;
  }) => ({
    name: "shortlist:create",
    payload,
  }),
} as const;

export const ROLE_VETTING_EVENTS = {
  QUESTION_ADD_SUCCESS: (payload: { jobId: number }) => {
    return {
      name: createRoleVettingEventKey("question_add_success"),
      payload,
    };
  },
  QUESTION_EDIT_SUCCESS: (payload: { jobId: number; questionId: number }) => {
    return {
      name: createRoleVettingEventKey("question_edit_success"),
      payload,
    };
  },
  QUESTION_REMOVE_SUCCESS: (payload: { jobId: number; questionId: number }) => {
    return {
      name: createRoleVettingEventKey("question_remove_success"),
      payload,
    };
  },
  QUESTION_ARCHIVE_SUCCESS: (payload: {
    jobId: number;
    questionId: number;
    totalAnswers: number;
    source: "archive_dialog" | "remove_dialog";
  }) => {
    return {
      name: createRoleVettingEventKey("question_archive_success"),
      payload,
    };
  },
  QUESTION_STATUS_TOGGLE: (payload: {
    jobId: number;
    questionId: number | null;
    type: "global" | "company";
    action: "enable" | "disable" | "enable_all" | "disable_all";
  }) => {
    return {
      name: createRoleVettingEventKey("question_status_toggle"),
      payload,
    };
  },
} as const;

function createRoleVettingEventKey<const TKey extends string>(eventKey: TKey) {
  return `role_vetting:${eventKey}` as const;
}
